var _style, _g;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCloudSleet = function SvgCloudSleet(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.7 395.5c15.4 0 27.8 12.5 27.8 27.8 0 15.4-12.5 27.8-27.8 27.8-15.4 0-27.8-12.5-27.8-27.8-.1-15.4 12.4-27.8 27.8-27.8M256 451.1c15.4 0 27.8 12.5 27.8 27.8 0 15.4-12.5 27.8-27.8 27.8-15.4 0-27.8-12.5-27.8-27.8s12.4-27.8 27.8-27.8M367.3 395.5c15.4 0 27.8 12.5 27.8 27.8 0 15.4-12.5 27.8-27.8 27.8-15.4 0-27.8-12.5-27.8-27.8 0-15.4 12.5-27.8 27.8-27.8",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h32.7l.1 35.5c0 8.9 7.2 16 16.1 15.9 2.9 0 5.6-.8 7.9-2.1 4.8-2.7 8-7.9 8-13.9l-.1-35.4H240l.2 84.4c0 8.9 7.2 16 16.1 15.9 2.9 0 5.6-.8 7.9-2.1 4.8-2.7 8-7.9 8-13.9L272 320h79.4l.1 35.5c0 8.9 7.2 16 16.1 15.9 2.9 0 5.6-.8 7.9-2.1 4.8-2.7 8-7.9 8-13.9l-.1-35.4H416c53 0 96-43 96-96s-43-96-96-96"
  }))));
};
export default SvgCloudSleet;